/**
 * Take a catalog item and return the number of missing details
 * @param {CatalogItem} catalogItem The catalog item to check
 *
 * @typedef {Object} CatalogItem
 * @property {number} width The width
 * @property {number} length The length
 * @property {number} height The height
 * @property {number} weight The weight
 *
 * @returns {number} The number of missing details
 *
 * @example
 * countMissingDetails({ width: null }) // returns 1
 * countMissingDetails({ width: null, height: 10, length: 10 }) // returns 2
 * countMissingDetails({ width: 10, height: 10 }) // returns 2
 * countMissingDetails({}) // returns 4
 * countMissingDetails() // returns MAX_MISSING_DETAILS (4)
 * countMissingDetails({ width: 10, height: 10, length: 10, weight: 10 }) // returns 0
 */
export const MAX_MISSING_DETAILS = 4;

export const countMissingDetails = (catalogItem) => {
  if (
    typeof catalogItem !== 'object' ||
    catalogItem === null ||
    catalogItem === undefined
  ) {
    return MAX_MISSING_DETAILS;
  }
  const { width, length, height, weight } = catalogItem;
  return (
    (width ? 0 : 1) + (length ? 0 : 1) + (height ? 0 : 1) + (weight ? 0 : 1)
  );
};
